import {useEffect, useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import {pathnames as P} from 'common/constants/pathnames';
import {refreshToken, logout} from '../modules/Auth/actions';
import moment from 'moment/moment';
import config from '../config/common.json';
import SplashScreen from '../common/components/SplashScreen';

const checkTokenExpire = expire => {
  const expireMoment = moment.unix(expire).subtract(config.api.refresh_gap);
  const currentMoment = moment();

  return currentMoment.isSameOrAfter(expireMoment);
};


const AuthGuard = ({children}) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const accessToken = useSelector(state => state.auth.accessToken, shallowEqual);
  const expire = useSelector(state => state.auth.expire, shallowEqual);
  const user = useSelector(state => state.user.user, shallowEqual);
  const isAuthorized = Boolean(accessToken) && Boolean(user);

  const [loading, setLoading] = useState(true);

  const updateToken = async token => {
    await dispatch(refreshToken(token));
  }

  const signOut = async token => {
    await dispatch(logout(token));
  }

  useEffect(() => {
    if (!isAuthorized) {
      setLoading(true)
      signOut(accessToken).finally(() => {
        history.replace(P.AUTH_LOGIN, {from: location.pathname});
        setLoading(false);
      })

    } else if (checkTokenExpire(expire)) {
      setLoading(true);
      updateToken(accessToken)
        .catch(async () => {
          try {
            await signOut(accessToken);
          } finally {
            history.replace(P.AUTH_LOGIN, {from: location.pathname});
          }
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [isAuthorized, history, location]);

  return loading ? <SplashScreen/> : children;
};

export default AuthGuard;